// Estado do modal de notificações da tela de jogo. Slide-up (mesma casca do
// modal de depósito), exibindo o inbox do Smartico. Singleton em nível de
// módulo, igual useGameDepositModal/useGameMobilePreview.

const isOpen = ref(false);

export function useGameNotificationsModal() {
  function open() {
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  return {
    isOpen,
    open,
    close,
  };
}
